import React, { FC, ReactNode, useRef } from 'react';
import './Dropdown.css';
import { useOutsideClick } from '@/Shared/Logic';

interface DropdownProps {
	isOpen: boolean;
	onClose: () => void;
	content: ReactNode;
	triggerRef: React.RefObject<HTMLElement>;
}

const Dropdown: FC<DropdownProps> = ({ isOpen, onClose, content, triggerRef }) => {
	const dropdownRef = useRef<HTMLDivElement>(null);
	useOutsideClick(triggerRef, dropdownRef, onClose);

	return isOpen ? (<div className="Dropdown elevation-3" data-testid="Dropdown" ref={dropdownRef}>{content}</div>) : null;
};

export default Dropdown;
